import axios from 'axios';
import { config } from '../config/environment';
import { getAuthToken } from './authToken';

const API_BASE_URL = config.apiBaseUrl;
const API_V1_URL = `${API_BASE_URL}/api/v1`;

export const getApiBaseUrl = () => API_BASE_URL;
export const getApiV1Url = () => API_V1_URL;

export const apiClient = axios.create({
  baseURL: API_V1_URL,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;